import axios from "axios";

const faqAPI = axios.create({
  baseURL: "https://faq.prowin.chat",
});

export const fetcher = (url) => faqAPI.get(url).then((res) => res.data);
